import React from "react";
import { Grid, Row, Col } from "react-bootstrap";

const AppGrid = ({ left, right }) => {
  return (
    <Grid style={{ marginTop: "1.5rem" }}>
      <Row className="show-grid">
        <Col xs={12} sm={6}>
          {left}
        </Col>
        <Col xs={12} sm={6}>
          {right}
        </Col>
      </Row>
    </Grid>
  );
};
export { AppGrid };
